// @ts-check
import { getDrugSort } from './utils/drug-sort'

const mostCommonOralDrugs = {
  Triazolam: 100,
  Diazepam: 80,
  Clonidine: 50,
}

const oralsDrugSort = getDrugSort(mostCommonOralDrugs)

/**
 * @typedef {{
 *   id: string
 *   name: string
 *   unit?: 'mg' | 'mcg'
 *   availableRoutes?: PreProcedureSedativeRoute[]
 *   common?: boolean
 * }} PreProcedureRawDef
 */

/**
 * @param {PreProcedureRawDef} overrides
 * @returns {PreProcedureSedative}
 */
const fillInDefaults = overrides => ({
  unit: 'mg',
  availableRoutes: ['PO', 'SL'],
  common: false,
  ...overrides,
})

/** @type {PreProcedureSedativeRoute[]} */
export const allPreProcedureSedRoutes = ['PO', 'SL', 'IM', 'IN']

/** @type {PreProcedureRawDef[]} */
const preProcedureSedativesRaw = [
  {
    id: '2599',
    name: 'Clonidine',
    unit: 'mg',
    common: true,
  },
  {
    id: '10767',
    name: 'Triazolam',
    common: true,
  },
  {
    id: '3322',
    name: 'Diazepam',
    common: true,
  },
  {
    id: '74667',
    name: 'Zaleplon',
  },
  {
    id: '6470',
    name: 'Lorazepam',
    availableRoutes: ['PO', 'SL', 'IM'],
  },
  {
    id: '5553',
    name: 'Hydroxyzine',
    availableRoutes: allPreProcedureSedRoutes,
  },
  {
    id: '6960',
    name: 'Midazolam',
    availableRoutes: allPreProcedureSedRoutes,
  },
  {
    id: '596',
    name: 'Alprazolam',
  },
  {
    id: '6130',
    name: 'Ketamine',
    availableRoutes: allPreProcedureSedRoutes,
  },
  {
    id: '6754',
    name: 'Meperidine',
    availableRoutes: ['PO', 'SL', 'IM'],
  },
  {
    id: '5489',
    name: 'Hydrocodone',
  },
  {
    id: '7052',
    name: 'Morphine',
    availableRoutes: ['PO', 'SL', 'IM'],
  },
  {
    id: '2344',
    name: 'Chloral hydrate',
  },
  {
    id: '4337',
    name: 'Fentanyl',
    unit: 'mcg',
    availableRoutes: allPreProcedureSedRoutes,
  },
  {
    id: '8745',
    name: 'Promethazine',
    availableRoutes: ['PO', 'SL', 'IM'],
  },
  {
    id: '3498',
    name: 'Diphenhydramine',
    availableRoutes: ['PO', 'SL', 'IM'],
  },
  {
    id: '48937',
    name: 'Dexmedetomidine',
    unit: 'mcg',
    availableRoutes: ['IN'],
  },
]

/** @type {Required<PreProcedureSedative>[]} */
export const preProcedureSedatives = preProcedureSedativesRaw
  .map(item => fillInDefaults(item))
  .sort(oralsDrugSort)

const toObject = arr =>
  arr.reduce((acc, item) => {
    acc[item.id] = item
    return acc
  }, {})

/**
 * @type {{
 *   [id: string]: Required<PreProcedureSedative>
 * }}
 */
export const preProcedureSedativesById = toObject(preProcedureSedatives)

export const oralSedatives = preProcedureSedatives.filter(
  item =>
    item.availableRoutes.includes('PO') || item.availableRoutes.includes('SL')
)

/**
 * @type {{
 *   [id: string]: Required<PreProcedureSedative>
 * }}
 */
export const oralSedativesById = toObject(oralSedatives)
